import { keepPreviousData, queryOptions } from "@tanstack/react-query";
import { useAppSelector } from "../../../../redux/hooks";
import { apiClient } from "../../../../zodios/client";

/** Filter option values (tag names, locked ids) for the keyword/target tables. Negative keywords share the keyword table. */
export const useGetV4TargetReportOptions = (targetType: "keyword" | "target" | "negative-keyword") => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  return queryOptions({
    queryKey: [{ entity: "V4TargetReportOptions", targetType, marketPlace }],
    queryFn: async () =>
      targetType === "target" ?
        await apiClient.getV4TargetReportOptions({ queries: { marketplace: marketPlace } })
      : await apiClient.getV4KeywordReportOptions({ queries: { marketplace: marketPlace } }),
    placeholderData: keepPreviousData,
  });
};
